import { DashboardModuleListItem } from '@domain-group/suit-theme'

import { digObject, formatDate } from '@domain-group/javascript-utils'

import useAssetLibrary from '@hooks/useAssetLibrary'

import type { AssetLibraryModel } from '@models/types'

const AssetLibraryListItem = (props: { assetLibrary: AssetLibraryModel }) => {
  const { assetLibrary } = props
  const {
    attachment_count, dates, title,
  } = assetLibrary

  const assetLibraryPayload = useAssetLibrary(assetLibrary)
  const {
    callbacks: { createOrEditAssetLibrary },
  } = assetLibraryPayload

  const createdDate = digObject(dates, 'created.date_time', '')
  const formattedDate = formatDate(createdDate, 'dd/MM/yyyy HH:mm', "'Created at' d LLLL y")

  return (
    <DashboardModuleListItem
      onClick={() => createOrEditAssetLibrary()}
      secondaryText={formattedDate}
      title={title}
    >
      {/*
       // @ts-expect-error TS2339 */}
      <DashboardModuleListItem.TertiaryText>
        {`${attachment_count} Attachment${attachment_count === 1 ? '' : 's'}`}
        {/*
       // @ts-expect-error TS2339 */}
      </DashboardModuleListItem.TertiaryText>
    </DashboardModuleListItem>
  )
}

export default AssetLibraryListItem
